
import { useStore } from './store';
const { group } = useStore();

// const cbg_tx3 = "https://cbg-tx3.res.netease.com/images"    // 藏宝阁链接
const res_tx3 = "https://tx3.res.netease.com"               // 网站组链接

let cbg_tx3 = ''
if (group.value === 'tx3') {
    cbg_tx3 = "https://cbg-tx3.res.netease.com/images"
}else if (group.value === 'tx2') {
    cbg_tx3 = "https://cbg-tianxia2.res.netease.com/game_res"
}else if (group.value === 'oldclassic') {
    // cbg_tx3 = "https://cbg-tianxia2.res.netease.com/game_res/res_oldclassic"
    // cbg_tx3 = "https://cbg-tianxia2.res.netease.com/game_res"
    // cbg_tx3 = "https://main-tianxia2.test.cbg.163.com/static/game_res/res_oldclassic"
    cbg_tx3 = "https://cbg-tianxia2.res.netease.com/game_res/res_oldclassic"
}else{
    console.error('❌ 未知的 group 值:', group.value);
}

const FINAL_SKILL_IMG_MAP = {
    "道强法重·坤": 7824,
    "拔山盖世·坤": 7825,
    "六合威扬·力": 7826,
    "六合威扬·敏": 7827,
    "六合威扬·魂": 7828,
    "六合威扬·念": 7829,
    "六合威扬·疾": 7830,
    "六合威扬·体": 7831,
    "黄泉八煞·白刃": 7832,
    "黄泉八煞·崩击": 7833,
    "黄泉八煞·阴伤": 7834,
    "黄泉八煞·猛毒": 7835,
    "黄泉八煞·真元": 7836,
    "黄泉八煞·狂风": 7837,
    "黄泉八煞·爆炎": 7838,
    "黄泉八煞·怒涛": 7839,
    "心眼通天": 7840,
    "八荒纵横·天封": 7841,
    "八荒纵横·地印": 7842,
    "八荒纵横·月异": 7843,
    "八荒纵横·星邪": 7844,
    "屠精戮怪·透甲": 7845,
    "屠精戮怪·破法": 7846,
    "屠精戮怪·猛攻": 7847,
    "屠精戮怪·狂法": 7848,
    "道强法重·乾": 7849,
    "拔山盖世·乾": 7850,
    "天罡正法·命": 7853,
    "天罡正法·技": 7854,
    "凌波虚渡": 7855,
    "三军用命·英": 7856,
    "三军用命·韧": 7857,
    "三军用命·强": 7858,
    "镇魂御魄·破法": 7859,
    "镇魂御魄·坚守": 7860,
    "镇魂御魄·不灭": 7861,
    "元魂化煞·法魂": 7862,
    "元魂化煞·刚力": 7863,
    "元魂化煞·狂澜": 7864,
    "元魂化煞·破军": 7865,
    "无懈·白刃": 7866,
    "无懈·崩击": 7867,
    "无懈·阴伤": 7868,
    "无懈·怒涛": 7869,
    "无懈·狂风": 7870,
    "无懈·爆炎": 7871,
    "无懈·猛毒": 7872,
    "无懈·真元": 7873,
    "无懈·完封": 7874,
    "骤雨": 8180,
    "明思": 8192,
    '众志成城·攻': 9473,
    '众志成城·伤': 9474,
    '众志成城·防': 9475,
    '众志成城·破': 9476,
    '众志成城·避': 9477,
    '众志成城·速': 9478,
    '天资聪慧·孩子': 9467,
    '天资聪慧·灵兽': 9468,
    '天资聪慧·元魂': 9469,
    '天资聪慧·觉醒': 9470,
    '玉树临风·正太': 9471,
    '闭月羞花·萝莉': 9472,
}

const FINAL_SKILL_LV_IMG_MAP = {
    "觉醒·巨炎": 'juyan',
    "觉醒·千军": 'qianjun',
    "觉醒·乱羽": 'luanyu',
    "觉醒·鬼舞": 'guiwu',
    "觉醒·龙卷": 'longjuan',
    "觉醒·凤舞": 'fengwu',
    "觉醒·葬花": 'zanghua',
    "觉醒·天剑": 'tianjian',
    "觉醒·冰夷": 'bingyi',
    "觉醒·闇世": 'bingyi',
    "觉醒·摩焰": 'bingyi',
}

const CHILD_WING_IMG_MAP = {
    "出类拔萃·童": 8,
    "锋芒毕现·童": 10,
    "名扬万里·童": 13,
    "傲视九州·童": 16,
    "震铄古今·童": 18,
    "睥睨寰宇·童": 20,
}

const force_int = value => {
    return parseInt(value)
}

const school_icon_base = {
    1: {
        1: 'hh1',
        2: 'tj1',
        3: 'ly1',
        4: 'wl1',
        5: 'tx1',
        6: 'yl1',
        7: 'bx1',
        8: 'yj1',
        9: 'gm1',
        10: 'lw1',
        11: 'yhg1',
        13: 'xm1',
    },
    2: {
        1: 'hh2',
        2: 'tj2',
        3: 'ly2',
        4: 'wl2',
        5: 'tx2',
        6: 'yl2',
        7: 'bx2',
        8: 'yj2',
        9: 'gm2',
        10: 'lw2',
        11: 'yhg2',
        13: 'xm1',
    }
}



// https://tx3.res.netease.com/qt/2015/bangv3/neiye/images/child_m.png

export const filters = {
    school_icon(school, sex) {
        // if (!school_icon_base[sex]) {
        //     return ''
        // }
        // return `${res_tx3}/qt/12/bang/images/face/${school_icon_base[sex][school]}_100x100.jpg`
        return `${cbg_tx3}/schools/head_2021/${school}_${sex}.png`
    },
    item_img(id) {
        // 道具图标
        // return `${cbg_tx3}/role/equip/${id}.jpg`
        return `${cbg_tx3}/item/${id}.jpg`
    },
    cbg_img(name) {
        return `${cbg_tx3}/${name}`
    },
    res_img(name) {
        return `${res_tx3}/${name}`
    },
    skill_img(id){
        return `${cbg_tx3}/skill/${id}.jpg`
    },

    jx_lv_img(level, minglian_value, name) {
        let _level = force_int(level)
        let _minglian_value = force_int(minglian_value)
        let star = 1
        if (_level >= 70 && _minglian_value >= 1051) { star = 3 }
        else if (_level >= 30 && _minglian_value >= 451) { star = 2 }

        let value = FINAL_SKILL_LV_IMG_MAP[name]
        let img_url = `${res_tx3}/qt/10/0427_yxb/images/juexing/${value}${star}.jpg`
        return img_url
    },

    child_wing_img(name) {
        let value = CHILD_WING_IMG_MAP[name]
        let img_url = `${cbg_tx3}/wing/${value}.gif`
        return img_url
    },

    jx_img(name) {
        let value = FINAL_SKILL_IMG_MAP[name]
        return `${res_tx3}/qt/10/0427_yxb/images/juexing/${value}.jpg`
    },

    yhz_img(id, stype) {
        let path = ''
        if (force_int(stype) == 2) {
            path = `${cbg_tx3}/skill/${id}.jpg`
        }
        else {
            path = `${cbg_tx3}/pskill/${id}.jpg`
        }
        return path
    },

    yhz_img2(id, stype) {
        let path = ''
        if (force_int(stype) == 2) {
            path = `${cbg_tx3}/skill/icon/${id}.jpg`
        }
        else {
            path = `${cbg_tx3}/pskill/${id}.jpg`
        }
        return path
    },

    bg_num(bg_num) {
        const ST_TREE_SRC_NEW_V3 = {
            0: "/st_tree_fox.png",
            1: "/st_tree_tiger.png",
            2: "/st_tree_bear.png",
            3: "/st_tree_rob.png",
            4: "/st_tree_ghost.png",
            5: "/st_tree_element.png",
            6: "/st_tree_corpse.png",
            7: "/st_tree_monkey.png",
            8: "/st_tree_water.png",
            9: "/st_tree_flower.png",
            10: "/st_tree_wood.png",
            11: "/st_tree_fox.png",
        }
        let filename = ST_TREE_SRC_NEW_V3[bg_num] || "/st_tree_fox.png"
        return `${res_tx3}/qt/10/0427_yxb/images/yuanhun${filename}`
    },

    child_pskill_img(id) {
        return `${cbg_tx3}/child/pskill/${id}.jpg`
    },


    child_tskill_img(id) {
        return `${cbg_tx3}/child/tskill/${id}.jpg`
    },


    shanhe_apperance_img(id) {
        return `${cbg_tx3}/shanheIcon/${id}.jpg`
    },


    shanhe_lingyao_img(id) {
        return `${res_tx3}/qt/12/bangv2/images/lingyao/book_${id}_1.png`
    },

    shanhe_icon(id) {
        return `${res_tx3}/qt/2015/0818_bang/images/${id}.jpg`
    },

    child_sex_img(key) {
        // #value = 'http://tx3.cbg.163.com/images/child_m.png'
        let value = `${res_tx3}/qt/2015/bangv3/neiye/images/child_m.png`
        if (key == 2) {
            // #value = 'http://tx3.cbg.163.com/images/child_f.png'
            value = `${res_tx3}/qt/2015/bangv3/neiye/images/child_f.png`
        }
        return value
    },


    fourbook_img(chn) {
        const FOURBOOK_IMG = {
            '天': 'tianshu_001_e95f7fd.jpg',
            '地': 'tianshu_002_a3eb13e.jpg',
            '玄': 'tianshu_003_950e2d2.jpg',
            '黄': 'tianshu_004_0397451.jpg',
        }
        return this.res_img(`pc/qt/20151231153005/images/${FOURBOOK_IMG[chn]}`)
    },

    chinese_num(n) {
        const NUMBER_DICT = {
            1: '一',
            2: '二',
            3: '三',
            4: '四',
            5: '五',
            6: '六',
            7: '七',
            8: '八',
            9: '九',
        }
        return NUMBER_DICT[n] || '一'
    }
}